import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {ChemicalProperty, CHEMICAL_PROPERTY_TO_DISPLAY_NAMES} from 'chemistry/ChemistryConstants';
import {FONT_PROXIMA_11} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface MoleculePropertyItemProps {
  chemicalProperty: ChemicalProperty;
  value: number | string | null;
  error: string | null;
}

export function MoleculePropertyItem({
  chemicalProperty,
  value,
  error,
}: MoleculePropertyItemProps): JSX.Element | null {
  return (
    <div className="simpleDivTable-row" key={chemicalProperty}>
      <div className={classNames('simpleDivTable-cell', css(styles.propertyNameColumn))}>
        {CHEMICAL_PROPERTY_TO_DISPLAY_NAMES[chemicalProperty]}
      </div>
      <div
        className={classNames('simpleDivTable-cell', css(styles.valueColumn))}
        {...getTestProps({
          component: 'MoleculePropertyItem',
          element: 'propertyValue',
          key: `${chemicalProperty}`,
        })}
      >
        {error ?? value}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  propertyNameColumn: {
    flex: 1,
  },
  valueColumn: {
    flex: 2,
  },
  smallHeader: {
    ...FONT_PROXIMA_11,
  },
});
